import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {Location} from '@angular/common';
import {AuthService} from '../../../auth/auth.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-user-register',
    templateUrl: './user-register.component.html',
    styleUrls: ['./user-register.component.scss'],
    providers: [
        AuthService
    ]
})
export class UserRegisterComponent implements OnInit {

    public model:  any = {};
    public errors: any = {};
    public loading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private location: Location,
        private authService: AuthService,
        private title: Title
    ) {
        this.title.setTitle('Register User');
    }

    ngOnInit(): void {

        this.userService.getById(this.route.snapshot.params.id).subscribe( user => {
            this.model = user;
        });
    }

    onCancel(): void {
        this.location.back();
    }

    onRegister(): void {
        this.loading = true;
        this.userService.register(this.model).subscribe( (result: any) => {
            this.loading = false;
            if (result.errors) {
                this.errors = result.errors;
            } else {
                this.authService.authenticate(result);
                this.onCancel();
            }
        });
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-register/user-register.component.ts